// @flow
import styled from "styled-components";

export const Draggable = styled.div`
    webkitoverflowscrolling: "touch";
`;

export const Hidden = styled.div`
    display: none;
`;

export const ModalOverlay = styled.div`
    display: flex;
    justify-content: center;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    padding: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    opacity: 1;
    animation: show 0.5s ease;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    @keyframes show {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
`;

export const Modal = styled.div`
    background-color: #fff;
    box-shadow: 0 0 0.625rem rgba(0, 0, 0, 0.2);

    width: 100%;
    height: fit-content;
    min-height: 100vh;

    @media only screen and (min-width: 768px) {
        width: 80%;
    }
`;

export const ModalContent = styled.div``;

export const CloseButton = styled.div`
    position: relative;
    opacity: 0.4;
    z-index: 99999;

    &:hover {
        opacity: 0.3;
    }
`;



// WEBPACK FOOTER //
// ./src/dialog/styled.js